import { combineReducers } from 'redux';
import authReducer, { AuthState } from 'src/redux/reducers/AuthReducer';
import autocompleteReducer, { AutocompleteState } from 'src/redux/reducers/AutocompleteReducer';
import alertReducer, { AlertState } from 'src/redux/reducers/AlertReducer';
import errorReducer, { ErrorsState } from 'src/redux/reducers/ErrorReducer';
import customfieldsReducer, { CustomfieldsState } from 'src/redux/reducers/CustomfieldsReducer';
import UserContactReducer, { UserContactState } from 'src/redux/reducers/UserContactReducer';
import currentOrganisationReducer, {
  CurrentOrganisationState,
} from 'src/redux/reducers/CurrrentOrganisationReducer';
import dataReducer, { DataState } from 'src/redux/reducers/DataReducer';
import formStatusReducer, { FormStatusState } from 'src/redux/reducers/FormReducer';
import languageReducer, { LanguageState } from 'src/redux/reducers/LanguageReducer';
import organisationReducer, { OrganisationState } from 'src/redux/reducers/OrganisationReducer';
import organisationListReducer, {
  OrganisationListState,
} from 'src/redux/reducers/OrganisationListReducer';
import organisationsUserReducer, {
  OrganisationsUserState,
} from 'src/redux/reducers/OrganisationsUserReducer';
import querybuilderReducer, { QuerybuilderState } from 'src/redux/reducers/QuerybuilderReducer';
import routeReducer, { RouteState } from 'src/redux/reducers/RouteReducer';
import userReducer, { UserState } from 'src/redux/reducers/UserReducer';
import interfaceReducer, { InterfaceState } from 'src/redux/reducers/InterfaceReducer';
import PresetReducer, { PresetState } from 'src/redux/reducers/PresetReducer';
import selectionReducer, { SelectionState } from 'src/redux/reducers/SelectionReducer';
import modalReducer, { ModalState } from 'src/redux/reducers/ModalReducer';
import contactsReducer, { ContactsState } from 'src/redux/reducers/ContactsReducer';
import contactGroupReducer, { ContactGroupState } from 'src/redux/reducers/ContactGroupReducer';
import invoiceReducer, { InvoicesState } from 'src/redux/reducers/InvoiceReducer';
import paymentReducer, { PaymentsState } from 'src/redux/reducers/PaymentReducer';
import taxesReducer, { TaxesState } from 'src/redux/reducers/TaxReducer';
import DialogReducer, { DialogState } from 'src/redux/reducers/DialogReducer';
import CurrentEntityReducer, { CurrentEntityState } from 'src/redux/reducers/CurrentEntityReducer';
import OrganisationBankAccountReducer, {
  OrganisationBankAccountState,
} from 'src/redux/reducers/OrganisationBankAccountReducer';
import ContactCreditCardReducer, {
  ContactCreditCardState,
} from 'src/redux/reducers/ContactCreditCardReducer';
import ContactBankAccountReducer, {
  ContactBankAccountState,
} from 'src/redux/reducers/ContactBankAccountReducer';
import advancedSearchReducer, {
  AdvancedSearchState,
} from 'src/redux/reducers/AdvancedSearchReducer';
import selectedPresetReducer, {
  CurrentPresetState,
} from 'src/redux/reducers/SelectedPresetReducer';
import productsReducer, { ProductsState } from 'src/redux/reducers/ProductsReducer';
import gatewaysReducer, { GatewaysState } from 'src/redux/reducers/GatewaysReducer ';
import adminsReducer, { AdminListState } from 'src/redux/reducers/AdminsReducer';
import menuReducer, { MenuState } from 'src/redux/reducers/MenuReducer';
import fundraisingReducer, { FundraisingListState } from 'src/redux/reducers/FundraisingReducer';
import guessInvoiceReducer, { GuessInvoicesState } from 'src/redux/reducers/GuessInvoiceReducer';
import UserCreditCardReducer, {
  UserCreditCardState,
} from 'src/redux/reducers/UserCreditCardReducer';
import UserBankAccountReducer, {
  UserBankAccountState,
} from 'src/redux/reducers/UserBankAccountReducer';
import QuickSearchReducer, { QuickSearchState } from 'src/redux/reducers/QuickSearchReducer';
import { Ambassador } from 'src/models/FundraisingModel';
import FundraisingTransactionsReducer, {
  FundraisingTransactionsList,
} from 'src/redux/reducers/FundraisingTransactionsReducer';
import AmbassadorsReducer from './AmbassadorsReducer';
import settingsReducer, { SettingsState } from './SettingReducer';
import ticketsReducer, { TicketsState } from './TicketsReducer';

//
export interface State {
  advancedSearch: AdvancedSearchState;
  admins: AdminListState;
  alert: AlertState;
  ambassadors: Ambassador[];
  auth: AuthState;
  autocomplete: AutocompleteState,
  contacts: ContactsState;
  contactBankAccounts: ContactBankAccountState;
  contactCreditcards: ContactCreditCardState;
  contactGroup: ContactGroupState,
  currentOrganisation: CurrentOrganisationState,
  currentEntity: CurrentEntityState,
  customfields: CustomfieldsState,
  data: DataState,
  dialog: DialogState,
  errors: ErrorsState;
  formStatus: FormStatusState,
  fundraisings: FundraisingListState,
  fundraisingTransaction: FundraisingTransactionsList;
  gateways: GatewaysState,
  invoices: InvoicesState;
  guessInvoices: GuessInvoicesState,
  interface: InterfaceState,
  language: LanguageState;
  menu: MenuState,
  modals: ModalState,
  organisation: OrganisationState;
  organisationList: OrganisationListState;
  organisationsUser: OrganisationsUserState;
  organisationBankAccounts: OrganisationBankAccountState;
  payments: PaymentsState;
  products: ProductsState;
  presets: PresetState,
  querybuilder: QuerybuilderState;
  route: RouteState;
  selected: SelectionState;
  selectedPreset: CurrentPresetState,
  settings: SettingsState;
  taxes: TaxesState;
  tickets: TicketsState;
  user: UserState;
  userContact: UserContactState;
  userCreditCards: UserCreditCardState;
  userBankAccounts: UserBankAccountState;
  quickSearch: QuickSearchState;
}

export const RootReducer = {
  advancedSearch: advancedSearchReducer,
  admins: adminsReducer,
  alert: alertReducer,
  ambassadors: AmbassadorsReducer,
  auth: authReducer,
  autocomplete: autocompleteReducer,
  contacts: contactsReducer,
  contactBankAccounts: ContactBankAccountReducer,
  contactCreditcards: ContactCreditCardReducer,
  contactGroup: contactGroupReducer,
  currentEntity: CurrentEntityReducer,
  currentOrganisation: currentOrganisationReducer,
  customfields: customfieldsReducer,
  data: dataReducer,
  dialog: DialogReducer,
  errors: errorReducer,
  formStatus: formStatusReducer,
  fundraisings: fundraisingReducer,
  fundraisingTransaction: FundraisingTransactionsReducer,
  gateways: gatewaysReducer,
  interface: interfaceReducer,
  invoices: invoiceReducer,
  guessInvoices: guessInvoiceReducer,
  language: languageReducer,
  menu: menuReducer,
  modals: modalReducer,
  organisation: organisationReducer,
  organisationList: organisationListReducer,
  organisationsUser: organisationsUserReducer,
  organisationBankAccounts: OrganisationBankAccountReducer,
  payments: paymentReducer,
  presets: PresetReducer,
  products: productsReducer,
  querybuilder: querybuilderReducer,
  route: routeReducer,
  selected: selectionReducer,
  selectedPreset: selectedPresetReducer,
  settings: settingsReducer,
  taxes: taxesReducer,
  tickets: ticketsReducer,
  user: userReducer,
  userContact: UserContactReducer,
  userCreditCards: UserCreditCardReducer,
  userBankAccounts: UserBankAccountReducer,
  quickSearch: QuickSearchReducer,
};

export default combineReducers<State>(RootReducer);
